import { useState } from 'react';
import { Menu, X, Globe } from 'lucide-react';

const CONTACT_PHONE = process.env.REACT_APP_CONTACT_PHONE;

export const Header = ({ lang, setLang, t }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#050505]/80 backdrop-blur-xl border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3" data-testid="logo">
            <div className="text-[#C5A059] font-semibold text-xl tracking-tight">
              INTERFLEX
            </div>
            <div className="hidden sm:block text-white/40 text-xs tracking-[0.2em] uppercase">
              Transport
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-white/70 hover:text-white text-sm transition-colors"
            >
              {t('nav.services')}
            </button>
            <button 
              onClick={() => scrollToSection('fleet')}
              className="text-white/70 hover:text-white text-sm transition-colors"
            >
              {t('nav.fleet')}
            </button>
            <button 
              onClick={() => scrollToSection('booking')}
              className="text-white/70 hover:text-white text-sm transition-colors"
            >
              {t('nav.book')}
            </button>
            <a 
              href={`tel:${CONTACT_PHONE}`}
              className="text-white/70 hover:text-white text-sm transition-colors"
            >
              {t('nav.contact')}
            </a>
          </nav>

          {/* Right side */}
          <div className="flex items-center gap-4">
            {/* Language Switcher */}
            <button
              type="button"
              onClick={() => setLang(lang === 'fr' ? 'en' : 'fr')}
              className="flex items-center gap-2 text-white/70 hover:text-white transition-colors cursor-pointer"
              data-testid="language-switcher"
            >
              <Globe size={16} />
              <span className="text-sm font-medium uppercase">{lang}</span>
            </button>

            {/* Mobile menu button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden text-white p-2"
              data-testid="mobile-menu-btn"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>

            {/* CTA Button - Desktop */}
            <button
              onClick={() => scrollToSection('booking')}
              className="hidden lg:block btn-primary text-sm py-3 px-6"
              data-testid="header-book-btn"
            >
              {t('nav.book')}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-white/10" data-testid="mobile-menu">
            <nav className="flex flex-col gap-4">
              <button 
                onClick={() => scrollToSection('services')}
                className="text-white/70 hover:text-white text-left py-2"
              >
                {t('nav.services')}
              </button>
              <button 
                onClick={() => scrollToSection('fleet')}
                className="text-white/70 hover:text-white text-left py-2"
              >
                {t('nav.fleet')}
              </button>
              <button 
                onClick={() => scrollToSection('booking')}
                className="text-white/70 hover:text-white text-left py-2"
              >
                {t('nav.book')}
              </button>
              <a 
                href={`tel:${CONTACT_PHONE}`}
                className="text-white/70 hover:text-white py-2"
              >
                {t('nav.contact')}
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
